/**
 * 客诉来源（source）UI 聚合规则（mobile DSP 端）。
 *
 * 与 desktop-web 同名工具对称：后端细粒度枚举 EMAIL/PHONE/SMS/OTHER 聚合为
 *   - 客服  CUSTOMER_SERVICE  ↔ EMAIL / PHONE
 *   - 系统  SYSTEM            ↔ SMS / OTHER
 *
 * 仅服务于 dsp/home/issueParcelWorkbench 模块，不下沉到全局 utils。
 */

export type ComplaintSourceFilter = 'CUSTOMER_SERVICE' | 'SYSTEM';

export const COMPLAINT_SOURCE_BACKEND_TO_FILTER: Record<string, ComplaintSourceFilter> = {
    EMAIL: 'CUSTOMER_SERVICE',
    PHONE: 'CUSTOMER_SERVICE',
    SMS: 'SYSTEM',
    OTHER: 'SYSTEM',
};

/** 把后端 source 归类到 UI 聚合分类，未识别值返回 undefined */
export function resolveComplaintSourceFilter(source?: string): ComplaintSourceFilter | undefined {
    if (!source) return undefined;
    return COMPLAINT_SOURCE_BACKEND_TO_FILTER[source];
}
